module.exports = __webpack_public_path__ + "img/panelView_greenBg_2_1.bb9ceca3.png";